module.exports = __webpack_public_path__ + "static/img/qr-frame-bunch.08f8e84c.svg";